<template>
  <LayoutDefault>
    <template v-slot:main>
      <div style="color: #172542; font-size: 24px; margin: 0 0 20px 0;">
        Regras de Follow up
      </div>
      <div>
        <b-button
          @click="openNewModal()"
          style="margin: 0 0 10px 0"
          pill
        >
          + Adicionar regra
        </b-button>

        <b-modal
          id="modal-fup-rule"
          :title="fupForm.rule_id ? 'Editar regra' : 'Criar Regra'"
          size="lg"
          hide-footer
          no-close-on-backdrop
          @hidden="closeModal()"
          :centered="true"
        >
          <div v-if="isLoading">
            <b-spinner></b-spinner>
          </div>
          <b-form
            ref="fupRuleModalForm"
            id="fupRuleModalForm"
            v-show="!isLoading"
            @submit.stop.prevent="submitLeadLifeCycle"
          >
            <p>
              ⚠️ M: minutos, H: horas, D: dias
              <br>
              Cada regra adicionada se baseia no tempo da regra anterior.
            </p>
            <hr>
            <p>
              <b>Plataforma: {{ $auth.user().platform }}</b>
            </p>
            <p v-if="fupForm.rule_id">
              <b>ID Regra: {{ fupForm.rule_id }}</b>
            </p>
            <b-form-group>
              <b-row>
                <b-col>
                  <div>Ação</div>
                  <v-select
                    v-model="fupForm.action"
                    :options="fupOptions.actions"
                    label="label"
                    index="id_action"
                    :filterable="false"
                    :clearable="false"
                    :placeholder="'Selecione a ação'"
                    :required="true"
                  ></v-select>
                </b-col>
                <b-col>
                  <div>Status</div>
                  <v-select
                    v-model="fupForm.status"
                    :options="fupOptions.status"
                    label="label"
                    index="id_status"
                    :filterable="false"
                    :clearable="false"
                    :placeholder="'Selecione o status'"
                    :required="true"
                  ></v-select>
                </b-col>
                <b-col>
                  <div>Canal</div>
                  <v-select
                    v-model="fupForm.channel"
                    :options="fupOptions.channels"
                    label="label"
                    index="id_channel"
                    :filterable="false"
                    :clearable="false"
                    :placeholder="'Selecione o Canal'"
                    :required="true"
                  ></v-select>
                </b-col>
              </b-row>
            </b-form-group>
            <hr/>
            <div>
              <b-button
                @click="addFupRuleStep()"
                pill
              >
                + Adicionar Regra
              </b-button>
            </div>
            <b-form-group
              v-for="(tentative_id, index) in reverseFupIndexes"
              :key="tentative_id"
              label-for="name-lead"
              style="margin: 25px 0;"
            >
              <b-row style="margin: 0 5px">
                <span v-if="$auth.user().profile === 'admin'">ID {{ tentative_id }}:&nbsp;</span>
                <span v-if="tentative_id === 0"><b>Finalização</b></span>
                <span v-else><b>Contato {{ index + 1 }}</b></span>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <b-form-input
                    v-model="fupForm.rules[tentative_id].expiration_time"
                    id="time-input"
                    :placeholder="'Tempo e unidade, ex.: 6H'"
                    :required="true"
                    :style="isValidExpirationTime(fupForm.rules[tentative_id].expiration_time) ? '' : 'border-color: red'"
                  ></b-form-input>
                </b-col>

                <b-col cols="6">
                  <v-select
                    v-if="tentative_id > 0"
                    v-model="fupForm.rules[tentative_id].template"
                    :options="fupOptions.templates"
                    label="template_name"
                    index="template_id"
                    :filterable="true"
                    :clearable="false"
                    :placeholder="'Selecione a mensagem template'"
                    :required="true"
                  ></v-select>
                </b-col>

                <b-col cols="2">
                  <b-button
                    v-if="tentative_id > 0"
                    @click="deleteFupRuleStep(tentative_id)"
                    pill
                    variant="danger"
                  >
                    Excluir
                  </b-button>
                </b-col>
              </b-row>
            </b-form-group>
            <b-row style="margin: 20px 0 0 0; display: flex; text-align: end">
              <b-col>
                <b-button @click="closeModal()" style="margin: 10px 20px;" pill>Cancelar</b-button>
                <b-button type="submit" :style="isValidForm ? 'background-color: #172542' : ''" pill :disabled="!isValidForm">
                  {{ fupForm.rule_id ? 'Atualizar regra' : 'Criar Regra' }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>
      </div>
      <div v-if="isLoading">
        <b-spinner></b-spinner>
      </div>
      <div
        v-else-if="formattedRules?.length === 0"
        style="margin: 20px 0;"
      >
        Nenhuma regra encontrada para esta plataforma
      </div>
      <div
        v-else
        style="overflow: hidden; border-radius: 15px;"
      >
        <table class="table" style="width: 100%; max-width: 1400px;" >
          <thead>
            <tr style="background-color: #98c1dd; color: #172542;">
              <th style="width: 160px">ID Regra</th>
              <th>Ação</th>
              <th>Canal</th>
              <th>Tentativas FUP</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="rule in formattedRules"
              :key="rule.rule_id"
            >
              <td>{{ rule.rule_id }}</td>
              <td>{{ rule.action.label }}</td>
              <td>{{ rule.channel.label }}</td>
              <td>
                <div style="overflow: hidden; border-radius: 15px;">
                  <table style="width: 100%">
                    <thead>
                      <tr style="background-color: #98c1dd; color: #172542">
                        <th>ID Template</th>
                        <th>Template</th>
                        <th>Tempo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="tentative in rule.tentativies" :key="tentative.tentative_id">
                        <td>{{ tentative.template_id }}</td>
                        <td style="width: 500px;">{{ tentative.template_name }}</td>
                        <td>{{ tentative.expiration_time }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
              <td>
                <b-button
                  @click="openEditFormModal(rule)"
                  pill
                >
                  Editar
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </LayoutDefault>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import SaasService from "@/services/SaasService";
import ActionService from "@/services/lead/ActionService";
import ClassifyService from "@/services/lead/ClassifyService";
import vSelect from "vue-select";

export default {
  components: {
    LayoutDefault,
    vSelect,
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature']),
    ...mapState('base', ['mainApi']),

    isValidForm() {
      for (let i = 0; i < this.fupForm.rules.length; i++) {
        if (!this.isValidExpirationTime(this.fupForm.rules[i].expiration_time)) return false;
        if (i > 0 && !this.fupForm.rules[i].template) return false;
      }

      return this.fupForm.action &&
        this.fupForm.status &&
        this.fupForm.channel
    },

    reverseFupIndexes () {
      const arr = [];

      for (let i = this.fupForm.rules.length - 1; i >= 0; i--) {
        arr.push(i);
      }

      return arr;
    }
  },

  data() {
    return {
      saasServiceInstance: new SaasService(),
      saasClassifyInstance: new ClassifyService(),
      actionServiceInstance: new ActionService(),

      isLoading: false,

      followUpRules: [],
      formattedRules: [],

      fupOptions: {
        actions: [],
        templates: [],
        status: [
          { id_status: 'lead_customer_service_started', label: 'Atendimento' },
        ]
      },

      fupForm: {
        rule_id: null,
        platform_id: this.$auth.user().id_platform,
        action: null,
        status: null,
        channel: null,
        rules: [
          {
            tentative_id: 0,
            expiration_time: null,
            template: null
          }
        ]
      },

      fupPayload: {
        rule_id: null,
        platform_id: null,
        action_id: null,
        channel_id: null,
        rule_time: null,
        status: null
      },
    }
  },

  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.getFollowUpRules(),
          this.getActions(),
          this.getTemplates(),
          this.getChannels(),
        ]);
        this.formattedRules = this.formatFollowUpRulesForTable(this.followUpRules?.rules?.Items);
      } catch (error) {
        console.error('Error fetching follow-ups:', error);
      } finally {
        this.isLoading = false;
      }
    },

    async getFollowUpRules() {
      this.isLoadingFollowUpRules = true;
      try {
        const response = await this.saasServiceInstance.getFupLifeCycleRules();
        this.followUpRules = response;
      } catch (error) {
        console.error('Error fetching follow-ups:', error);
      } finally {
        this.isLoadingFollowUpRules = false;
      }
    },

    async getActions() {
      try {
        const response = await this.actionServiceInstance.index();
        this.fupOptions.actions = response;
      } catch (error) {
        console.error('Error fetching actions:', error);
      }
    },

    async getTemplates() {
      try {
        const response = await this.saasServiceInstance.getTemplateMessage(this.$auth.user().id_platform);

        response.forEach(template => {
          if (!template.template_name) {
            template.template_name = '(Template sem nome)';
          }
        });

        this.fupOptions.templates = response;
      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    },

    async getChannels() {
      try {
        // const response = await this.saasServiceInstance.getPlatformChannels(this.$auth.user().id_platform);
        const response = [
          { id_channel: 9, label: 'Chatwoot' },
          { id_channel: 5, label: 'App' }
        ];
        this.fupOptions.channels = response;
      } catch (error) {
        console.error('Error fetching channels:', error);
      }
    },

    clearModal() {
      this.fupForm = {
        rule_id: null,
        platform_id: this.$auth.user().id_platform,
        action: null,
        rules: [
          {
            tentative_id: 0,
            expiration_time: null,
            template: null
          }
        ]
      };

      this.fupPayload = {
        rule_id: null,
        platform_id: null,
        action_id: null,
        channel_id: null,
        rule_time: null,
        status: null
      };
    },

    formatFollowUpRulesForTable(rules) {
      try {
        if (!rules) return;

        const filteredRules = rules.filter(rule => rule?.platform?.id === this.$auth.user().id_platform);

        const formattedRules = filteredRules.map(rule => ({
          rule_id: rule.rule_id,
          platform_id: rule.platform_id,
          status: rule.status,
          action: {
            id_action: rule.action_id,
            label: this.fupOptions.actions.find(a => a.id_action === rule.action_id)?.label
          },
          channel: {
            id_channel: rule.channel_id,
            label: this.fupOptions.channels.find(a => a.id_channel === rule.channel_id)?.label
          },
          platform_name: rule.platform.name,
          tentativies: rule.rule_time.tentativies.map(tentative => ({
            tentative_id: tentative.tentative_id,
            template_id: tentative.template_id,
            template_name: this.getTemplateNameById(tentative.template_id),
            expiration_time: tentative.expiration_time
          }))
        }));

        // Invert "tentativies" array to display in the correct order
        formattedRules.forEach(rule => {
          if (Array.isArray(rule.tentativies)) {
            rule.tentativies.reverse();
          }
        });

        return formattedRules
      } catch (error) {
        console.error('Error formatting follow-ups for table display:', error);
      }
    },

    openNewModal() {
      this.clearModal()
      this.$bvModal.show('modal-fup-rule')
    },

    closeModal() {
      this.$bvModal.hide('modal-fup-rule');
    },

    openEditFormModal (ruleGroup) {
      this.clearModal();

      this.fupForm.rule_id = ruleGroup.rule_id;
      this.fupForm.action = this.fupOptions.actions.find(a => a.id_action === ruleGroup.action.id_action);
      this.fupForm.channel = this.fupOptions.channels.find(a => a.id_channel === ruleGroup.channel.id_channel);
      this.fupForm.status = this.fupOptions.status.find(s => s.id_status === ruleGroup.status);
      this.fupForm.platform_id = ruleGroup.platform_id;
      this.fupForm.rules = [];

      for (let i = ruleGroup.tentativies.length - 1; i >= 0; i--) {
        this.fupForm.rules.push({
          tentative_id: ruleGroup.tentativies[i].tentative_id,
          expiration_time: ruleGroup.tentativies[i].expiration_time,
          template: this.fupOptions.templates.find(t => t.id_template === ruleGroup.tentativies[i].template_id)
        });
      }

      this.$bvModal.show('modal-fup-rule')
    },

    async submitLeadLifeCycle () {
      try {
        const ruleTime = [];

        for (const rule of this.fupForm.rules) {
          ruleTime.push({
            tentative_id: rule?.tentative_id,
            expiration_time: rule?.expiration_time,
            template_id: rule?.template?.id_template || 0
          });
        }

        this.fupPayload = {
          rule_id: this.fupForm.rule_id,
          platform_id: this.fupForm.platform_id,
          action_id: this.fupForm.action.id_action,
          channel_id: this.fupForm.channel.id_channel,
          rule_time: JSON.stringify({ tentativies: ruleTime }),
          status: this.fupForm.status.id_status
        };

        if (this.fupPayload.rule_id) {
          await this.saasServiceInstance.updateFupLifeCycleRule(this.fupPayload.rule_id, this.fupPayload);
        } else {
          this.fupPayload.rule_id = Date.now();
          await this.saasServiceInstance.createFupLifeCycleRule(this.fupPayload);
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.closeModal();
        this.loadData();
      }
    },

    getTemplateNameById(templateId) {
      const template = this.fupOptions.templates.find(t => t.id_template === templateId);
      return template ? template.template_name : '(Finalização)';
    },

    addFupRuleStep () {
      for (let i = 0; i < this.fupForm?.rules?.length; i++) {
        if (this.fupForm?.rules[i]?.tentative_id > 0) {
          this.fupForm.rules[i].tentative_id += 1;
        }
      }

      this.fupForm.rules.splice(1, 0, {
        tentative_id: 1,
        expiration_time: null,
        template: null
      });
    },

    deleteFupRuleStep(index) {
      this.fupForm.rules.splice(index, 1);

      for (let i = 0; i < this.fupForm?.rules?.length; i++) {
        if (this.fupForm?.rules[i]?.tentative_id >= index) {
          this.fupForm.rules[i].tentative_id -= 1;
        }
      }
    },

    isValidExpirationTime(value) {
      if (!value) return false;
      const pattern = /^[1-9][0-9]*[MHD]$/;
      return pattern.test(value);
    },
  },

  created () {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
</style>
